module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image-cropper"
  }, [_c('div', {
    ref: "canvas",
    staticClass: "crop-canvas"
  }, [_c('div', {
    ref: "container",
    staticClass: "crop-area"
  }, [_c('div', {
    ref: "image",
    staticClass: "crop-image",
    style: ({
      width: (_vm.cropBounds.width * _vm.imageRatio) + 'px',
      height: (_vm.cropBounds.height * _vm.imageRatio) + 'px'
    }),
    attrs: {
      "draggable": "false"
    }
  }, [_c('img', {
    style: ({
      position: _vm.cropBounds.width < _vm.image.width ? 'absolute' : 'relative',
      top: -((_vm.boundsOffset[1] + _vm.cropBounds.top) / 2) * _vm.imageRatio + 'px',
      left: -((_vm.boundsOffset[0] + _vm.cropBounds.left) / 2) * _vm.imageRatio + 'px',
      width: (_vm.image.width * _vm.imageRatio) + 'px',
      height: (_vm.image.height * _vm.imageRatio) + 'px'
    }),
    attrs: {
      "src": _vm.imageData,
      "draggable": "false"
    }
  }), _vm._v(" "), (_vm.cropBounds.width < _vm.image.width) ? _c('div', {
    staticClass: "crop-maximum",
    style: ({
      top: (((_vm.boundsOffset[1] - _vm.cropBounds.top) / 2) * _vm.imageRatio) - 4 + 'px',
      left: (((_vm.boundsOffset[0] - _vm.cropBounds.left) / 2) * _vm.imageRatio) - 4 + 'px',
      width: (_vm.cropBounds.width * _vm.imageRatio) + 'px',
      height: (_vm.cropBounds.height * _vm.imageRatio) + 'px'
    }),
    attrs: {
      "draggable": "false"
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    ref: "controls",
    staticClass: "crop-controls",
    style: ({
      top: _vm.cropTop + 'px',
      left: _vm.cropLeft + 'px',
      width: _vm.cropWidth + 'px',
      height: _vm.cropHeight + 'px'
    }),
    attrs: {
      "draggable": "true"
    }
  }, [_c('div', {
    staticClass: "crop-control crop-top-left",
    attrs: {
      "draggable": "true"
    }
  }, [_c('div', {
    staticClass: "crop-info"
  }, [(_vm.dragStartPosition !== null) ? _c('span', [_vm._v("\n                            " + _vm._s(-Math.round((_vm.crop.left - _vm.dragStartCrop.left - _vm.dragStartPosition[0]) + _vm.dragStartPosition[0])) + ",\n                            " + _vm._s(-Math.round((_vm.crop.top - _vm.dragStartCrop.top - _vm.dragStartPosition[1]) + _vm.dragStartPosition[1])) + "\n                        ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "crop-control crop-top-right",
    attrs: {
      "draggable": "true"
    }
  }, [_c('div', {
    staticClass: "crop-info"
  }, [(_vm.dragStartPosition !== null) ? _c('span', [_vm._v("\n                            " + _vm._s(Math.round(((_vm.crop.left + _vm.crop.width) - (_vm.dragStartCrop.left + _vm.dragStartCrop.width) - _vm.dragStartPosition[0]) +
    _vm.dragStartPosition[0])) + ",\n                            " + _vm._s(-Math.round((_vm.crop.top - _vm.dragStartCrop.top - _vm.dragStartPosition[1]) + _vm.dragStartPosition[1])) + "\n                        ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "crop-control crop-bottom-left",
    attrs: {
      "draggable": "true"
    }
  }, [_c('div', {
    staticClass: "crop-info"
  }, [(_vm.dragStartPosition !== null) ? _c('span', [_vm._v("\n                            " + _vm._s(-Math.round((_vm.crop.left - _vm.dragStartCrop.left - _vm.dragStartPosition[0]) + _vm.dragStartPosition[0])) + ",\n                            " + _vm._s(Math.round(((_vm.crop.top + _vm.crop.height) - (_vm.dragStartCrop.top + _vm.dragStartCrop.height) - _vm.dragStartPosition[1]) +
    _vm.dragStartPosition[1])) + "\n                        ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "crop-control crop-bottom-right",
    attrs: {
      "draggable": "true"
    }
  }, [_c('div', {
    staticClass: "crop-info"
  }, [(_vm.dragStartPosition !== null) ? _c('span', [_vm._v("\n                            " + _vm._s(Math.round(((_vm.crop.left + _vm.crop.width) - (_vm.dragStartCrop.left + _vm.dragStartCrop.width) - _vm.dragStartPosition[0]) +
    _vm.dragStartPosition[0])) + ",\n                            " + _vm._s(Math.round(((_vm.crop.top + _vm.crop.height) - (_vm.dragStartCrop.top + _vm.dragStartCrop.height) - _vm.dragStartPosition[1]) +
    _vm.dragStartPosition[1])) + "\n                        ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "crop-info-bar top"
  }, [_vm._v(_vm._s(Math.round(_vm.crop.width)))]), _vm._v(" "), _c('div', {
    staticClass: "crop-info-bar left"
  }, [_vm._v(_vm._s(Math.round(_vm.crop.height)))]), _vm._v(" "), _c('div', {
    staticClass: "crop-info-bar bottom"
  }, [_vm._v(_vm._s(Math.round(_vm.crop.width)))]), _vm._v(" "), _c('div', {
    staticClass: "crop-info-bar right"
  }, [_vm._v(_vm._s(Math.round(_vm.crop.height)))])])])]), _vm._v(" "), _c('div', {
    staticClass: "image-info"
  }, [(_vm.cropBounds.width < _vm.image.width) ? _c('div', {
    class: {
      'image-info-block': true,
      'same': Math.round(_vm.cropBounds.width) === Math.round(_vm.crop.width) && Math.round(_vm.cropBounds.height) === Math.round(_vm.crop.height),
    }
  }, [_c('strong', [_vm._v("New Size")]), _vm._v(" "), _c('br'), _vm._v("\n            " + _vm._s(Math.round(_vm.cropBounds.width)) + " x " + _vm._s(Math.round(_vm.cropBounds.height)) + "px\n        ")]) : _c('div', {
    class: {
      'image-info-block': true,
      'same': Math.round(_vm.image.width) === Math.round(_vm.crop.width) && Math.round(_vm.image.height) === Math.round(_vm.crop.height),
    }
  }, [_c('strong', [_vm._v("New Size")]), _vm._v(" "), _c('br'), _vm._v("\n            " + _vm._s(Math.round(_vm.image.width)) + " x " + _vm._s(Math.round(_vm.image.height)) + "px\n        ")]), _vm._v(" "), (_vm.cropBounds.width < _vm.image.width) ? _c('div', {
    class: {
      'image-info-block': true,
      'changed': Math.round(_vm.cropBounds.width) !== Math.round(_vm.crop.width) || Math.round(_vm.cropBounds.height) !== Math.round(_vm.crop.height),
        'same': Math.round(_vm.cropBounds.width) === Math.round(_vm.crop.width) && Math.round(_vm.cropBounds.height) === Math.round(_vm.crop.height),
    }
  }, [_c('strong', [_vm._v("Cropped Size")]), _vm._v(" "), _c('br'), _vm._v("\n            " + _vm._s(Math.round(_vm.crop.width)) + " x " + _vm._s(Math.round(_vm.crop.height)) + "px\n        ")]) : _c('div', {
    class: {
      'image-info-block': true,
      'changed': Math.round(_vm.image.width) !== Math.round(_vm.crop.width) || Math.round(_vm.image.height) !== Math.round(_vm.crop.height),
        'same': Math.round(_vm.image.width) === Math.round(_vm.crop.width) && Math.round(_vm.image.height) === Math.round(_vm.crop.height),
    }
  }, [_c('strong', [_vm._v("Cropped Size")]), _vm._v(" "), _c('br'), _vm._v("\n            " + _vm._s(Math.round(_vm.crop.width)) + " x " + _vm._s(Math.round(_vm.crop.height)) + "px\n        ")])]), _vm._v(" "), _c('h3', {
    staticClass: "subtitle has-text-centered"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.showResult = !_vm.showResult
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.showResult ? 'Hide Preview' : 'Show Preview') + "\n        ")])]), _vm._v(" "), (_vm.showResult) ? _c('div', [_c('div', {
    staticClass: "crop-preview center",
    style: ({
      width: Math.round(_vm.crop.width / _vm.cropRatio) + 'px',
      height: Math.round(_vm.crop.height / _vm.cropRatio) + 'px'
    })
  }, [_c('img', {
    style: ({
      width: Math.round(_vm.image.width / _vm.cropRatio) + 'px',
      height: Math.round(_vm.image.height / _vm.cropRatio) + 'px',
      top: -Math.round(_vm.crop.top / _vm.cropRatio) + 'px',
      left: -Math.round(_vm.crop.left / _vm.cropRatio) + 'px'
    }),
    attrs: {
      "src": _vm.imageData
    }
  })])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d002244"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/src/components/misc/ImageCropper.vue
// module id = 506
// module chunks = 0